import React from "react"
import { pathOr } from "ramda"
import { renderOrderNumber } from "../../app/helpers"
import { Typography, TypographyOwnProps } from "@mui/material"

interface DeliveryModeProps extends TypographyOwnProps {
  order: string
  info?: {
    address: string
    area: string
    busstop: string
    phone: string
    email?: string
  }
}

export const capitalize = (str: string) =>
  str ? `${str.charAt(0).toUpperCase()}${str.slice(1, str.length)}` : str

const orderDeliveryTypes = (deliveryInfo: any) => ({
  physical: "Physical",
  pickup: "Pick up",
  other: `Deliver with Order - ${renderOrderNumber(
    deliveryInfo?.jointOrderId,
  )}`,
  online: "Online",
  none: "None",
})

export const DeliveryMode = ({ order, info, ...props }: DeliveryModeProps) => {
  return (
    <>
      <Typography {...props}>
        Delivery mode: {` ${pathOr("None", [order], orderDeliveryTypes(info))}`}
      </Typography>
      {info && order === "physical" ? (
        <>
          <Typography variant="body2">
            {`Address: ${info.address}, ${capitalize(info.area)} `}
          </Typography>
          <Typography variant="body2">
            {`Nearest b/stop: ${info?.busstop}`}
          </Typography>
          <Typography variant="body2">{`Phone: ${info.phone}`}</Typography>
        </>
      ) : null}

      {info && order !== "physical" && order !== "other" ? (
        <>
          <Typography variant="body2">{`Email: ${info.email}`}</Typography>
        </>
      ) : null}
    </>
  )
}
